exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#refeach{position:fixed;bottom:70px;right:10px}", "", {"version":3,"sources":["D:/xampp/htdocs/PhotoGenius_V2/src/components/manage_file.vue"],"names":[],"mappings":"AACA,SACE,eAAgB,AAChB,YAAa,AACb,UAAY,CACb","file":"manage_file.vue","sourcesContent":["\n#refeach {\r\n  position: fixed;\r\n  bottom: 70px;\r\n  right: 10px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d3685f8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/manage_file.vue
// module id = 288
// module chunks = 0